import { createState } from '../helpers/state-subject';
import '../../styles/web-components/product-secondary.scss';
import { showModal } from '../services/dialog.service';
import './product-option-dropdown.ts';
import { allOptionsSelected, getRecommendationParameters, matchesCurrentAndSelectedOptions, NO_SELECTED_VARIANT, shownVariant, UNAVAILABLE_VARIANT } from './product-shared';
import { showInlineCart } from '../helpers/utils';
import { addToCart } from '../services/cart.service';
class ProductSecondary extends HTMLElement {
    constructor() {
        super();
    }
    productId;
    selectedVariantStore;
    selectedOptionsStore;
    teardown;
    connectedCallback() {
        this.productId = this.getAttribute('product-id');
        // @ts-expect-error dynamic variable
        const initialSelections = window[`initialDefaultSelections${this.productId}`];
        this.selectedOptionsStore = createState(initialSelections);
        this.selectedVariantStore = createState(undefined);
        const unsubs = [];
        const onSelectedOptionsChange = (selectedOptions) => {
            if (!selectedOptions) {
                return;
            }
            console.log(`selected options for ${this.productId}`, selectedOptions);
            this.updateProductOptionsDisplay(selectedOptions);
            if (allOptionsSelected(selectedOptions)) {
                const selectedVariant = this.getProductVariantsFromOptions(selectedOptions)[0] || UNAVAILABLE_VARIANT;
                this.selectedVariantStore.set(selectedVariant);
            }
            else {
                this.selectedVariantStore.set(NO_SELECTED_VARIANT);
            }
        };
        const onSelectedVariantChange = (variant) => {
            console.log(`selected variant for ${this.productId}`, variant);
            const addToCartBtn = this.querySelector('.product__cta');
            if (!addToCartBtn) {
                return;
            }
            if (variant?.available) {
                addToCartBtn.removeAttribute("disabled");
                addToCartBtn.textContent = window.productUi.ctas.addCart;
            }
            else {
                addToCartBtn.setAttribute("disabled", "true");
                if (variant && !variant.available) {
                    addToCartBtn.textContent = window.productUi.ctas.outOfStock;
                }
                else if (variant === UNAVAILABLE_VARIANT) {
                    addToCartBtn.textContent = window.productUi.ctas.unavailable;
                }
                else {
                    addToCartBtn.textContent = window.productUi.ctas.addCart;
                }
            }
        };
        unsubs.push(this.selectedOptionsStore.subscribe(onSelectedOptionsChange));
        unsubs.push(this.selectedVariantStore.subscribe(onSelectedVariantChange));
        const onDropdownChange = (e) => {
            const detail = e.detail;
            this.selectedOptionsStore.set({ ...this.selectedOptionsStore.get() || {}, ...detail });
        };
        // eslint-disable-next-line wc/require-listener-teardown
        this.addEventListener("dropdown:valueChanged", onDropdownChange);
        const formEl = this.querySelector("form");
        const onSubmit = (e) => {
            const target = e.target;
            e.preventDefault();
            if (target.checkValidity()) {
                const selectedVariant = this.selectedVariantStore.get();
                addToCart({ items: [{ id: selectedVariant.variantID, quantity: 1 }] }).then((data) => this.handleAddToCart(data))
                    .catch((err) => { console.error(err); });
            }
        };
        if (formEl) {
            formEl.addEventListener("submit", onSubmit);
        }
        this.teardown = () => {
            unsubs.forEach((u) => u());
            this.removeEventListener("dropdown:valueChanged", onDropdownChange);
            if (formEl) {
                formEl.removeEventListener("submit", onSubmit);
            }
        };
    }
    disconnectedCallback() {
        this.teardown?.();
        this.teardown = undefined;
    }
    getProductVariantsFromOptions(selectedOptions) {
        return this.getVariants().filter(v => {
            return Object.entries(selectedOptions).filter(entry => !!entry[1]).reduce((acc, curr) => {
                const [key, val] = curr;
                return acc && v.optionsMap[key] === val;
            }, true);
        });
    }
    updateProductOptionsDisplay(selectedOptions) {
        this.querySelectorAll('.product-option-dropdown__item-input').forEach((el) => {
            const labelEl = el.nextElementSibling;
            labelEl.classList.remove('product-option-dropdown__item-label--out-of-stock', 'product-option-dropdown__item-label--unavailable'); // reset style classes
            const optionName = el.id.split("-")[1];
            const optionValue = el.value;
            const isSelectedOption = selectedOptions[optionName] === optionValue;
            let selectBtnTextEl = null;
            if (isSelectedOption) {
                selectBtnTextEl = el.closest('product-option-dropdown').querySelector(".product-option-dropdown__selected-value");
                selectBtnTextEl.classList.remove("product-option-dropdown__selected-value--out-of-stock", "product-option-dropdown__selected-value--unavailable");
                selectBtnTextEl.textContent = labelEl.querySelector(".product-option-dropdown__label-value").textContent;
            }
            const associatedVariants = this.getAssociatedVariants(optionName, optionValue, selectedOptions);
            if (associatedVariants.length) {
                if (!associatedVariants.find(av => av.available)) {
                    labelEl.classList.add("product-option-dropdown__item-label--out-of-stock");
                    if (selectBtnTextEl) {
                        selectBtnTextEl.classList.add("product-option-dropdown__selected-value--out-of-stock");
                    }
                }
            }
            else {
                labelEl.classList.add("product-option-dropdown__item-label--unavailable");
                if (selectBtnTextEl) {
                    selectBtnTextEl.classList.add("product-option-dropdown__selected-value--unavailable");
                }
            }
        });
    }
    getAssociatedVariants(optionName, optionValue, selectedOptions) {
        const associatedVariants = this.getVariants().filter(v => matchesCurrentAndSelectedOptions(v, optionName, optionValue, selectedOptions));
        return associatedVariants;
    }
    getVariants() {
        // @ts-expect-error dynamic variable causes ts issue
        return window[`variantsArray${this.productId}`].filter(shownVariant);
    }
    handleAddToCart(response) {
        if (window.UNTUCKitConfig.showAddToCartOverlay) {
            if (response?.items?.length) {
                const addToCartOverlay = document.createElement('add-to-cart-overlay');
                addToCartOverlay.setAttribute('cart-line-item-data', JSON.stringify(response.items[0]));
                const selectedVariant = this.selectedVariantStore.get();
                const optionsForRec = selectedVariant.originalOptionsMap ?? selectedVariant.optionsMap;
                const recommendationParameters = getRecommendationParameters({ fit: optionsForRec.fit, size: optionsForRec.size, gender: window.productDepartment, sku: selectedVariant.sku, productId: `${this.productId}` });
                addToCartOverlay.setAttribute('recommendation-parameters', JSON.stringify(recommendationParameters));
                showModal([addToCartOverlay], { classes: 'add-to-cart-overlay' });
            }
            else {
                console.error("item added to cart successfully but no data returned");
            }
        }
        else {
            showInlineCart();
        }
    }
}
if (!window.customElements.get("product-secondary")) {
    customElements.define("product-secondary", ProductSecondary);
}
